import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "inner" };
const _hoisted_2 = { class: "h_left" };
const _hoisted_3 = {
    key: 0,
    class: "h_right"
};
const _hoisted_4 = {
    type: "button",
    class: "img_box btn",
    id: "menu-btn"
};
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "menu sp" };
const _hoisted_8 = { class: "sp-padding" };
const _hoisted_9 = { class: "header-profile-hover-list" };
const _hoisted_10 = { class: "menu_box" };
const _hoisted_11 = { class: "header-profile-hover-view" };
const _hoisted_12 = {
    key: 0,
    class: "header-profile-hover-list"
};
const _hoisted_13 = { class: "menu_box" };
const _hoisted_14 = { class: "header-profile-hover-view" };
const _hoisted_15 = { class: "header-profile-hover-view" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "header-profile-hover-view" };
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "header-profile-hover-view" };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = { class: "header-profile-hover-view" };
const _hoisted_22 = { key: 3 };
const _hoisted_23 = { class: "header-profile-hover-view" };
const _hoisted_24 = { key: 4 };
const _hoisted_25 = { class: "header-profile-hover-view" };
const _hoisted_26 = {
    key: 1,
    class: "header-profile-hover-list"
};
const _hoisted_27 = { class: "menu_box" };
const _hoisted_28 = { class: "header-profile-hover-view" };
const _hoisted_29 = { class: "header-profile-hover-view" };
const _hoisted_30 = { class: "header-profile-hover-view" };
const _hoisted_31 = { class: "header-profile-hover-view" };
const _hoisted_32 = { class: "header-profile-hover-view" };
const _hoisted_33 = { class: "header-profile-hover-view" };
const _hoisted_34 = { class: "header-profile-hover-view" };
const _hoisted_35 = { class: "header-profile-hover-list" };
const _hoisted_36 = { class: "menu_box" };
const _hoisted_37 = { class: "header-profile-hover-view" };
const _hoisted_38 = { class: "header-profile-hover-view" };
const _hoisted_39 = { class: "header-profile-hover-list" };
const _hoisted_40 = { class: "header-profile-hover-menu-borderTop2" };
const _hoisted_41 = { class: "header-profile-hover-view" };
const _hoisted_42 = { class: "nav pc" };
const _hoisted_43 = { id: "pc_menu" };
const _hoisted_44 = {
    key: 0,
    class: "sec_2"
};
const _hoisted_45 = { key: 1 };
const _hoisted_46 = { key: 2 };
const _hoisted_47 = { key: 3 };
const _hoisted_48 = { key: 4 };
const _hoisted_49 = { key: 5 };
const _hoisted_50 = { key: 6 };
const _hoisted_51 = {
    key: 7,
    class: "sec_2"
};
const _hoisted_52 = { key: 8 };
const _hoisted_53 = { key: 9 };
const _hoisted_54 = { key: 10 };
const _hoisted_55 = { key: 11 };
const _hoisted_56 = { key: 12 };
const _hoisted_57 = { key: 13 };
const _hoisted_58 = { class: "sec_3" };
const _hoisted_59 = { class: "sec_4" };
const _hoisted_60 = {
    key: 1,
    class: "h_right2"
};
import { computed, watch } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-vue3';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
import { AuthRole, UserType, PlanCategory } from '@util/Consts';
const MAX_NUM = 99;
const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
export default /*@__PURE__*/ _defineComponent({
    __name: 'header',
    props: {
        common: {},
        photo: {},
        type: {}
    },
    setup(__props) {
        const props = __props;
        const body = document.body;
        // 通知数
        const notification = computed(() => {
            var _a;
            const count = (_a = props.common.notification) !== null && _a !== void 0 ? _a : 0;
            if (MAX_NUM < count) {
                return MAX_NUM;
            }
            return count;
        });
        const pageTitle = computed(() => {
            if (props.common.page_title) {
                return `${props.common.page_title}｜ShareMentors (シェアメンターズ)`;
            }
            return 'ShareMentors';
        });
        const signUpRoute = computed(() => {
            return route().current('mentor.home') || props.type == UserType.MENTOR
                ? route('signup', { type: UserType.MENTOR, plan_id: PlanCategory.FREE_PLAN })
                : route('signup');
        });
        const showUserMode = computed(() => {
            if (props.common.role === AuthRole.MENTOR) {
                return '相談モードへ切替';
            }
            else if (props.common.role === AuthRole.QUESTIONER) {
                return '回答モードへ切替';
            }
            return '会員モード切替';
        });
        const setIconColor = computed(() => {
            const role = props.common.role;
            if (role === AuthRole.MENTOR) {
                return 'p1';
            }
            else if (role === AuthRole.QUESTIONER) {
                return 'p2';
            }
            else if (role === AuthRole.ADMIN) {
                return 'p3';
            }
            return '';
        });
        const onLogo = () => {
            let url = props.common.role ? route('question.index') : route('home');
            onGeneralLink(url);
        };
        const onAdminLink = (url) => {
            body === null || body === void 0 ? void 0 : body.classList.remove('fixed');
            location.href = url;
        };
        const onGeneralLink = (url) => {
            body === null || body === void 0 ? void 0 : body.classList.remove('fixed');
            Inertia.get(url);
        };
        const getPhoto = computed(() => {
            var _a, _b;
            return (_a = props.photo) !== null && _a !== void 0 ? _a : (_b = props.common['auth.user']) === null || _b === void 0 ? void 0 : _b.photo;
        });
        const onProfile = () => {
            const name = props.common.role === AuthRole.MENTOR ? 'mentor.profile.show' : 'profile.show';
            onGeneralLink(route(name));
        };
        const onClickLogout = () => {
            sessionStorage.removeItem(USER_HOME_SEARCH_SESSION_KEY);
            // ログアウト
            window.location.href = route('logout');
        };
        watch(() => props.common.error_code, (value) => { if (value)
            Alert.RequestError(value); });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (_openBlock(), _createElementBlock("header", null, [
                _createElementVNode("title", null, _toDisplayString(pageTitle.value), 1),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h1", null, [
                            _createElementVNode("a", { onClick: onLogo }, [
                                _createVNode(ImageFrame, { src: "images/common/i_logo_sm.svg" })
                            ])
                        ])
                    ]),
                    (props.common.role)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (props.common.role)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["r_bt profile", setIconColor.value]),
                                    style: { "margin-left": "6px" }
                                }, [
                                    _createElementVNode("button", _hoisted_4, [
                                        _createVNode(ImageFrame, {
                                            src: (_a = getPhoto.value) !== null && _a !== void 0 ? _a : 'images/user/default.svg'
                                        }, null, 8, ["src"])
                                    ]),
                                    (props.common.role === _unref(AuthRole).MENTOR)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "A"))
                                        : _createCommentVNode("", true),
                                    (props.common.role === _unref(AuthRole).QUESTIONER)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Q"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(ImageFrame, {
                                            src: "images/common/i_cross.svg",
                                            id: "sp-cross"
                                        }),
                                        _createElementVNode("ul", _hoisted_8, [
                                            _createElementVNode("li", _hoisted_9, [
                                                _createElementVNode("ul", _hoisted_10, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", { onClick: onLogo }, [
                                                            _createElementVNode("div", _hoisted_11, [
                                                                _createVNode(ImageFrame, { src: "images/common/i_home.svg" }),
                                                                _cache[30] || (_cache[30] = _createElementVNode("p", null, "ホーム", -1))
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            (props.common.role !== _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                                    _createElementVNode("ul", _hoisted_13, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", { onClick: onProfile }, [
                                                                _createElementVNode("div", _hoisted_14, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_prof2.svg" }),
                                                                    _cache[31] || (_cache[31] = _createElementVNode("p", null, "プロフィール", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            (props.common.role !== _unref(AuthRole).ADMIN &&
                                                                ((_b = props.common['auth.user']) === null || _b === void 0 ? void 0 : _b.type) === _unref(UserType).MENTOR)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 0,
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => (onGeneralLink(_ctx.route('user.switch'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_15, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_change.svg" }),
                                                                        _createElementVNode("p", null, _toDisplayString(showUserMode.value), 1)
                                                                    ])
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        (props.common.role === _unref(AuthRole).QUESTIONER)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                                                _createElementVNode("a", {
                                                                    onClick: _cache[1] || (_cache[1] = ($event) => (onGeneralLink(_ctx.route('payment.show'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_17, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_pay.svg" }),
                                                                        _cache[32] || (_cache[32] = _createElementVNode("p", null, "支払方法", -1))
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (props.common.role === _unref(AuthRole).QUESTIONER)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                                                _createElementVNode("a", {
                                                                    onClick: _cache[2] || (_cache[2] = ($event) => (onGeneralLink(_ctx.route('plan.show'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_19, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                                        _cache[33] || (_cache[33] = _createElementVNode("p", null, "料金プラン", -1))
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (props.common.role === _unref(AuthRole).QUESTIONER)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                                                _createElementVNode("a", {
                                                                    onClick: _cache[3] || (_cache[3] = ($event) => (onGeneralLink(_ctx.route('payment_history.index'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_21, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_payment.svg" }),
                                                                        _cache[34] || (_cache[34] = _createElementVNode("p", null, "支払履歴", -1))
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (props.common.role === _unref(AuthRole).MENTOR)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                                                _createElementVNode("a", {
                                                                    onClick: _cache[4] || (_cache[4] = ($event) => (onGeneralLink(_ctx.route('mentor.payee.edit'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_23, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_bank.svg" }),
                                                                        _cache[35] || (_cache[35] = _createElementVNode("p", null, "振込先登録", -1))
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (props.common.role === _unref(AuthRole).MENTOR)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                                                _createElementVNode("a", {
                                                                    onClick: _cache[5] || (_cache[5] = ($event) => (onGeneralLink(_ctx.route('mentor.reward_history.index'))))
                                                                }, [
                                                                    _createElementVNode("div", _hoisted_25, [
                                                                        _createVNode(ImageFrame, { src: "images/common/i_payment.svg" }),
                                                                        _cache[36] || (_cache[36] = _createElementVNode("p", null, "報酬履歴", -1))
                                                                    ])
                                                                ])
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                                    _createElementVNode("ul", _hoisted_27, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[6] || (_cache[6] = ($event) => (onAdminLink(_ctx.route('admin.system_setting.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_28, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_system.svg" }),
                                                                    _cache[37] || (_cache[37] = _createElementVNode("p", null, "システム設定", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[7] || (_cache[7] = ($event) => (onAdminLink(_ctx.route('admin.user_list.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_29, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_userlist.svg" }),
                                                                    _cache[38] || (_cache[38] = _createElementVNode("p", null, "ユーザー一覧", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[8] || (_cache[8] = ($event) => (onAdminLink(_ctx.route('admin.payment_status_list.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_30, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                                    _cache[39] || (_cache[39] = _createElementVNode("p", null, "決済状況一覧", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[9] || (_cache[9] = ($event) => (onAdminLink(_ctx.route('admin.reward_history.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_31, [
                                                                    _createVNode(ImageFrame, { src: "assets/admin/img/icon/ico_reward.svg" }),
                                                                    _cache[40] || (_cache[40] = _createElementVNode("p", null, "報酬履歴", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[10] || (_cache[10] = ($event) => (onAdminLink(_ctx.route('admin.sale_history.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_32, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                                    _cache[41] || (_cache[41] = _createElementVNode("p", null, "売上履歴", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[11] || (_cache[11] = ($event) => (onAdminLink(_ctx.route('admin.env_setting.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_33, [
                                                                    _createVNode(ImageFrame, { src: "assets/admin/img/icon/ico_env_setting.svg" }),
                                                                    _cache[42] || (_cache[42] = _createElementVNode("p", null, "ENV設定", -1))
                                                                ])
                                                            ])
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                onClick: _cache[12] || (_cache[12] = ($event) => (onAdminLink(_ctx.route('admin.payment_history.index'))))
                                                            }, [
                                                                _createElementVNode("div", _hoisted_34, [
                                                                    _createVNode(ImageFrame, { src: "images/common/i_bank.svg" }),
                                                                    _cache[43] || (_cache[43] = _createElementVNode("p", null, "一括支払履歴", -1))
                                                                ])
                                                            ])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("li", _hoisted_35, [
                                                _createElementVNode("ul", _hoisted_36, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            onClick: _cache[13] || (_cache[13] = ($event) => (onGeneralLink(_ctx.route('help.index'))))
                                                        }, [
                                                            _createElementVNode("div", _hoisted_37, [
                                                                _createVNode(ImageFrame, { src: "images/common/i_help.svg" }),
                                                                _cache[44] || (_cache[44] = _createElementVNode("p", null, "ヘルプ", -1))
                                                            ])
                                                        ])
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            onClick: _cache[14] || (_cache[14] = ($event) => (onGeneralLink(_ctx.route('inquiry.create'))))
                                                        }, [
                                                            _createElementVNode("div", _hoisted_38, [
                                                                _createVNode(ImageFrame, { src: "images/common/i_contact.svg" }),
                                                                _cache[45] || (_cache[45] = _createElementVNode("p", null, "お問合せ", -1))
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("li", _hoisted_39, [
                                                _createElementVNode("ul", _hoisted_40, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", { onClick: onClickLogout }, [
                                                            _createElementVNode("div", _hoisted_41, [
                                                                _createVNode(ImageFrame, { src: "images/common/i_logout.svg" }),
                                                                _cache[46] || (_cache[46] = _createElementVNode("p", null, "ログアウト", -1))
                                                            ])
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("nav", _hoisted_42, [
                                        _createElementVNode("ul", _hoisted_43, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("a", { onClick: onLogo }, [
                                                    _createVNode(ImageFrame, { src: "images/common/i_home.svg" }),
                                                    _cache[47] || (_cache[47] = _createElementVNode("p", null, "ホーム", -1))
                                                ])
                                            ]),
                                            (props.common.role !== _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                                    _createElementVNode("a", { onClick: onProfile }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_prof2.svg" }),
                                                        _cache[48] || (_cache[48] = _createElementVNode("p", null, "プロフィール", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role !== _unref(AuthRole).ADMIN &&
                                                ((_c = props.common['auth.user']) === null || _c === void 0 ? void 0 : _c.type) === _unref(UserType).MENTOR)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[15] || (_cache[15] = ($event) => (onGeneralLink(_ctx.route('user.switch'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_change.svg" }),
                                                        _createElementVNode("p", null, _toDisplayString(showUserMode.value), 1)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).QUESTIONER)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[16] || (_cache[16] = ($event) => (onGeneralLink(_ctx.route('payment.show'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_pay.svg" }),
                                                        _cache[49] || (_cache[49] = _createElementVNode("p", null, "支払方法", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).QUESTIONER)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[17] || (_cache[17] = ($event) => (onGeneralLink(_ctx.route('plan.show'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                        _cache[50] || (_cache[50] = _createElementVNode("p", null, "料金プラン", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).QUESTIONER)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[18] || (_cache[18] = ($event) => (onGeneralLink(_ctx.route('payment_history.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_payment.svg" }),
                                                        _cache[51] || (_cache[51] = _createElementVNode("p", null, "支払履歴", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).MENTOR)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[19] || (_cache[19] = ($event) => (onGeneralLink(_ctx.route('mentor.payee.edit'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_bank.svg" }),
                                                        _cache[52] || (_cache[52] = _createElementVNode("p", null, "振込先登録", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).MENTOR)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_50, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[20] || (_cache[20] = ($event) => (onGeneralLink(_ctx.route('mentor.reward_history.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_payment.svg" }),
                                                        _cache[53] || (_cache[53] = _createElementVNode("p", null, "報酬履歴", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[21] || (_cache[21] = ($event) => (onAdminLink(_ctx.route('admin.system_setting.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_system.svg" }),
                                                        _cache[54] || (_cache[54] = _createElementVNode("p", null, "システム設定", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[22] || (_cache[22] = ($event) => (onAdminLink(_ctx.route('admin.user_list.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_userlist.svg" }),
                                                        _cache[55] || (_cache[55] = _createElementVNode("p", null, "ユーザー一覧", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[23] || (_cache[23] = ($event) => (onAdminLink(_ctx.route('admin.payment_status_list.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                        _cache[56] || (_cache[56] = _createElementVNode("p", null, "決済状況一覧", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_54, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[24] || (_cache[24] = ($event) => (onAdminLink(_ctx.route('admin.reward_history.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "assets/admin/img/icon/ico_reward.svg" }),
                                                        _cache[57] || (_cache[57] = _createElementVNode("p", null, "報酬履歴", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[25] || (_cache[25] = ($event) => (onAdminLink(_ctx.route('admin.sale_history.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_plan.svg" }),
                                                        _cache[58] || (_cache[58] = _createElementVNode("p", null, "売上履歴", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[26] || (_cache[26] = ($event) => (onAdminLink(_ctx.route('admin.env_setting.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "assets/admin/img/icon/ico_env_setting.svg" }),
                                                        _cache[59] || (_cache[59] = _createElementVNode("p", null, "ENV設定", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (props.common.role === _unref(AuthRole).ADMIN)
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_57, [
                                                    _createElementVNode("a", {
                                                        onClick: _cache[27] || (_cache[27] = ($event) => (onAdminLink(_ctx.route('admin.payment_history.index'))))
                                                    }, [
                                                        _createVNode(ImageFrame, { src: "images/common/i_bank.svg" }),
                                                        _cache[60] || (_cache[60] = _createElementVNode("p", null, "一括支払履歴", -1))
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("li", _hoisted_58, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[28] || (_cache[28] = ($event) => (onGeneralLink(_ctx.route('help.index'))))
                                                }, [
                                                    _createVNode(ImageFrame, { src: "images/common/i_help.svg" }),
                                                    _cache[61] || (_cache[61] = _createElementVNode("p", null, "ヘルプ", -1))
                                                ])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("a", {
                                                    onClick: _cache[29] || (_cache[29] = ($event) => (onGeneralLink(_ctx.route('inquiry.create'))))
                                                }, [
                                                    _createVNode(ImageFrame, { src: "images/common/i_contact.svg" }),
                                                    _cache[62] || (_cache[62] = _createElementVNode("p", null, "お問合せ", -1))
                                                ])
                                            ]),
                                            _createElementVNode("li", _hoisted_59, [
                                                _createElementVNode("a", { onClick: onClickLogout }, [
                                                    _createVNode(ImageFrame, { src: "images/common/i_logout.svg" }),
                                                    _cache[63] || (_cache[63] = _createElementVNode("p", null, "ログアウト", -1))
                                                ])
                                            ])
                                        ])
                                    ])
                                ], 2))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createVNode(_unref(Link), {
                                class: "bt_login",
                                href: "/login"
                            }, {
                                default: _withCtx(() => _cache[64] || (_cache[64] = [
                                    _createTextVNode("ログイン")
                                ])),
                                _: 1,
                                __: [64]
                            }),
                            _createVNode(_unref(Link), {
                                class: _normalizeClass(["bt_entry", _ctx.route().current('mentor.home') || props.type == _unref(UserType).MENTOR ? 'bt_mentor' : '']),
                                href: signUpRoute.value
                            }, {
                                default: _withCtx(() => _cache[65] || (_cache[65] = [
                                    _createElementVNode("span", null, "無料", -1),
                                    _createTextVNode("登録")
                                ])),
                                _: 1,
                                __: [65]
                            }, 8, ["class", "href"])
                        ]))
                ])
            ]));
        };
    }
});
